module.exports = __webpack_public_path__ + "static/media/homepage-module-3.4d46bfc1.jpg";